class Spinner {
    constructor(spinner) {
        this.spinner = spinner;

        if (this.spinner._activated) {
            return;
        }

        this.spinner.addEventListener("animationend", () => {
            this.spinner.classList.add("is-hidden");
            this.spinner.classList.remove("is-closing");
        });

        this.spinner._activated = true;
    }

    start() {
        this.spinner.classList.remove("is-closing", "is-hidden");
    }

    end() {
        this.spinner.classList.add("is-closing");
    }
}

export default Spinner;
